import AuthorizedSignatory from 'components/AuthorizedSignatory';
import { useAppDispatch, useAppSelector } from 'hooks';

import { getPerson } from 'pages/Profile/selectors';
import { Permissions } from 'entities/dashboard';

import { getFinancialSignatory, getAuthorizing } from '../selectors';
import { updateBusinessFinancial } from '../thunks';
import { setAuthorizing } from '../financialSlice';

const FinancialSignatory = ({ getValues }) => {
  const dispatch = useAppDispatch();

  const signatory = useAppSelector(getFinancialSignatory);
  const authorizing = useAppSelector(getAuthorizing);
  const person = useAppSelector(getPerson);

  const handleAuthorize = async () => {
    const data = getValues();

    dispatch(setAuthorizing(true));
    await dispatch(
      updateBusinessFinancial({
        ...data,
        signatoryAttestationPersonsId: person.personsId,
      }),
    );
    dispatch(setAuthorizing(false));
  };

  return (
    <div className="bg-gray-50 rounded-lg border p-6 mt-16">
      <AuthorizedSignatory
        loading={authorizing}
        signatory={signatory}
        onClick={handleAuthorize}
        permission={Permissions.financialInfo}
      />
    </div>
  );
};

export default FinancialSignatory;
